module.exports = __webpack_public_path__ + "nucleo-icons.5c78b4cf03771fd22873.woff2";


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/assets/fonts/nucleo-icons.woff2
// module id = ../../../../../src/assets/fonts/nucleo-icons.woff2
// module chunks = 3